import { Directive, OnInit, ElementRef, Input, OnDestroy } from '@angular/core';
import { ChartConfiguration, ChartDataset, ChartData } from 'chart.js';
import Chart from 'chart.js/auto';

import 'chartjs-plugin-datalabels';
// import * as _ from 'lodash';
// eslint-disable-next-line @angular-eslint/directive-selector
@Directive({ selector: '[NguChartjs]' })
// eslint-disable-next-line @angular-eslint/directive-class-suffix
export class NguChartjs implements OnInit, OnDestroy {
  _seed: any;
  Color: any;
  private defaultColors: Array<number[]> = [
    [255, 55, 132],
    [54, 162, 235],
    [75, 192, 192],
    [247, 120, 37],
    [153, 102, 255],
    [0, 168, 198],
    [55, 159, 122],
    [204, 39, 56],
    [139, 98, 138],
    [143, 190, 0],
    [96, 96, 96],
    [77, 83, 96]
  ];
  // private defaultColors: Array<number[]> = [
  //   [255, 99, 132],
  //   [54, 162, 235],
  //   [255, 206, 86],
  //   [231, 233, 237],
  //   [75, 192, 192],
  //   [151, 187, 205],
  //   [220, 220, 220],
  //   [247, 70, 74],
  //   [70, 191, 189],
  //   [253, 180, 92],
  //   [148, 159, 177],
  //   [77, 83, 96]
  // ];
  Samples = [
    '#FF3784',
    '#36A2EB',
    '#4BC0C0',
    '#F77825',
    '#9966FF',
    '#00A8C6',
    '#379F7A',
    '#CC2738',
    '#8B628A',
    '#8FBE00',
    '#606060'
  ];

  _config: ChartConfiguration;
  isChartInitialized: boolean;
  cts: CanvasRenderingContext2D;
  chart: Chart;

  @Input('config')
  set config(data: ChartConfiguration) {
    // this._options = _.cloneDeep(data);
    this._config = data;
    this.isChartInitialized && this._initilizeChart();
  }
  @Input('options') options: any;

  constructor(private el: ElementRef) {}

  ngOnInit() {
    this.isChartInitialized = true;
    this.cts = this.el.nativeElement.getContext('2d');
    this._initilizeChart();
  }

  private _initilizeChart() {
    if (!this._config) return;
    // console.log('chartInit');
    this._config.data.datasets = this.analizeDataSet(
      this._config.data.datasets
    );
    // console.log(this.options.labels);
    // if (this._config.type === 'pie')
    let formats;
    switch (this._config.type) {
     /* case 'multibar':
        // console.log('mutibar');
        formats = {
          align: 'end',
          anchor: 'end',
          color: context => {
            return context.dataset.backgroundColor;
          },
          font: context => {
            const w = context.chart.width;
            return {
              size: w < 512 ? 20 : 18,
              weight: 900
            };
          },
          formatter: (value, context) => {
            return context.chart.data.labels[context.dataIndex];
          }
        };
        break; */
      case 'pie':
        // console.log('pie');
        formats = {
          // backgroundColor: context => {
          //   return context.dataset.backgroundColor;
          // },
          // borderColor: 'white',
          // borderRadius: 25,
          // borderWidth: 2,
          color: 'white',
          // display: context => {
          //   const dataset = context.dataset;
          //   const count = dataset.data.length;
          //   const value = dataset.data[context.dataIndex];
          //   return value > count * 1.5;
          // },
          font: {
            size: 16,
            weight: 'bold'
          },
          textAlign: 'start',
          formatter: Math.round
        };
        break;
      case 'bar':
        // console.log('bar');
        formats = {
          color: 'black',
          display: context => {
            return context.dataset.data[context.dataIndex] > 0;
          },
          font: {
            weight: 'bold'
          },
          formatter: Math.round
        };
        break;
    }
    this._config.options.plugins = { datalabels: formats };
    this.chart = new Chart(this.cts, this._config);
    // this.chart.data.datasets = this._options.data.datasets;
  }

  analizeDataSet(data?: ChartDataset[]): ChartDataset[] {
    return data.map((elem, index) => {
      return Object.assign(
        elem,
        elem.backgroundColor
          ? null
          : this.getColors(this._config.type, index, elem.data.length)
      );
    });
  }

  ngOnDestroy() {
    this.destroy();
  }

  set chartData(data: ChartData) {
    // data = this.copy(data) as ChartData;
    // const data = _.cloneDeep(datas);
    if (data.labels) this._config.data.labels = this.copy(data.labels);

    if (data?.datasets)
    this._config.data.datasets = this.analizeDataSet(data?.datasets);
    if(this.chart?.data){
      this.chart.data.datasets = this._config?.data?.datasets;
      this.chart.update();
    }
  }

  copy(data): any {
    return JSON.parse(JSON.stringify(data));
  }

  destroy() {
    if (this.chart) {
      this.chart.destroy();
      this.chart = null;
    }
  }

  private getColors(chartType: string, index: number, count: number) {
    if (chartType === 'pie' || chartType === 'doughnut') {
      return this.formatPieColors(this.generateColors(count));
    }

    // if (chartType === 'polarArea') {
    //   return formatPolarAreaColors(this.generateColors(count));
    // }

    // if (chartType === 'line' || chartType === 'radar') {
    //   return formatLineColor(generateColor(index));
    // }

    if (chartType === 'bar' || chartType === 'horizontalBar') {
      return this.formatBarColor(this.generateColor(index));
    }
    // return generateColor(index);
  }

  private getRandomInt(min: number, max: number): number {
    return Math.floor(Math.random() * (max - min + 1)) + min;
  }

  private getRandomColor(): number[] {
    return [
      this.getRandomInt(0, 255),
      this.getRandomInt(0, 255),
      this.getRandomInt(0, 255)
    ];
  }

  private generateColors(count: number): Array<number[]> {
    const colorsArr: Array<number[]> = new Array(count);
    for (let i = 0; i < count; i++) {
      colorsArr[i] = this.defaultColors[i] || this.getRandomColor();
    }
    return colorsArr;
  }

  private formatPieColors(colors: Array<number[]>) {
    return {
      backgroundColor: colors.map(color => this.rgba(color, 0.6)),
      borderColor: colors.map(() => '#fff'),
      pointBackgroundColor: colors.map(color => this.rgba(color, 1)),
      pointBorderColor: colors.map(() => '#fff'),
      pointHoverBackgroundColor: colors.map(color => this.rgba(color, 1)),
      pointHoverBorderColor: colors.map(color => this.rgba(color, 1))
    };
  }

  private formatBarColor(colors: number[]) {
    return {
      backgroundColor: this.rgba(colors, 0.6),
      borderColor: this.rgba(colors, 1),
      hoverBackgroundColor: this.rgba(colors, 0.8),
      hoverBorderColor: this.rgba(colors, 1)
    };
  }

  private generateColor(index: number): number[] {
    return this.defaultColors[index] || this.getRandomColor();
  }

  private rgba(colour: number[], opacity: number): string {
    return `rgba(${colour.concat(opacity).join(',')})`;
  }

  // color(offset) {
  //   const count = this.Samples.length;
  //   const index = offset === undefined ? this.rand(0, count) : offset;
  //   return this.Samples[index % count];
  // }

  // colors(config) {
  //   const cfg = config || {};
  //   const color = cfg.color || this.color(0);
  //   const count = cfg.count !== undefined ? cfg.count : 8;
  //   const method = cfg.mode ? this.Color[cfg.mode] : null;
  //   const values = [];
  //   let i, f, v;

  //   for (i = 0; i < count; ++i) {
  //     f = i / count;

  //     if (method) {
  //       v = method.call(this.Color(color), f).rgbString();
  //     } else {
  //       v = this.color(i);
  //     }

  //     values.push(v);
  //   }

  //   return values;
  // }

  // rand(min, max) {
  //   const seed = this._seed;
  //   min = min === undefined ? 0 : min;
  //   max = max === undefined ? 1 : max;
  //   this._seed = (seed * 9301 + 49297) % 233280;
  //   return min + this._seed / 233280 * (max - min);
  // }
}
